export enum EventAction {
  VISITED = 'visited',
  STARTED = 'started',
  PREVIEWED = 'previewed',
}

export enum EventTarget {
  PAGE = 'page',
  DEMO = 'demo',
  PRESENTATION = 'presentation',
}
